import castArray from 'lodash/castArray';
import { getConfig } from '../config';
import Api from './axios';
import log from './logApi';
import { addToCartAnalytics } from '../utils/analytics';

/**
Not all THD API endpoints return a standard http error. Some return a 200 OK
with an error message inside. In these cases we want to simulate http errors
in these api clients for the sake of SRP and so the rest of the app doesn't
have to be responsible for an api endpoint's questionable design decisions.
*/

const executeApiCall = (request) => {
  const api = Api();
  Object.assign(api.defaults, { withCredentials: true, crossDomain: true });
  return api.post(getConfig()?.thdCartApiUrl, request);
};

const toItemDetail = (item) => ({
  fulfillmentLocation: '77573',
  fulfillmentMethod: 'ShipToHome',
  quantity: 1,
  itemId: item.omsId,
  unitPrice: item.price,
  name: item.name,
});

export const addItemsToCart = (localStoreId, itemDetails) => {
  const itemDetailsList = castArray(itemDetails);
  const addToCartData = {
    CartRequest: {
      itemDetails: itemDetailsList.map(() => toItemDetail(itemDetails)),
      localStoreId: localStoreId.toString(),
    },
  };

  return executeApiCall(addToCartData).then(() => {
    addToCartAnalytics(addToCartData.CartRequest.itemDetails);
  }).catch((ee) => {
    log(`Error adding to cart: ${ee}, ${JSON.stringify(addToCartData)}`);
  });
};

export const checkoutRedirect = () => {
  if (typeof window !== 'undefined') {
    window.location.href = `${getConfig()?.homeDepotAddToCartUrlBase}/mycheckout/checkout#/checkout`;
  }
};
